/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { GoogleLogin, GoogleLogout } from "react-google-login";
import React, { useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { globalClientId, serverUrl } from "../../secure_config4js";

// reactstrap components
import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Input,
  InputGroup,
  NavbarBrand,
  Navbar,
  NavLink,
  Nav,
  Container,
  Modal,
  NavbarToggler,
  ModalHeader,
} from "reactstrap";
import { BrowserRouter as Router, Link } from "react-router-dom";
import logo from "../../assets/img/ziro.png"

function AdminNavbar(props) {
  const [collapseOpen, setcollapseOpen] = React.useState(false);
  const [modalSearch, setmodalSearch] = React.useState(false);
  const [color, setcolor] = React.useState("navbar-transparent");
  const [loggedIn, setLoggedIn] = React.useState(false);
  const [userImgURL, setUserURL] = React.useState(logo);
  const [userObj, setUserObj] = React.useState(null);
  const [timer, setTimer] = React.useState(null);
  const history = useHistory();

  const getHigherResProviderPhotoUrl = function (photoURL, providerId) {
    //workaround to get higer res profile picture
    let result = photoURL;
    if (providerId.includes("google")) {
      result = photoURL.replace("s96-c", "s400-c");
    } else if (providerId.includes("facebook")) {
      result = `${photoURL}?type=large`;
    }
    return result;
  };

  const responseGoogle = (response) => {
    var id_token = response.tokenId;
    if (!id_token) {
      id_token = response.id_token;
      // clear ziroatoken cookie
      document.cookie = "ziroatoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie =
      "ziroatoken=" + id_token + ";domain=;Secure;SameSite=None";

      setRefreshTimeout(response.expires_at);
      return
    }
    setUserObj(response);

    //alert(id_token)
    //console.log(id_token);
    var xhr = new XMLHttpRequest();
    xhr.open("POST", serverUrl + "/tokensignin");
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.onload = function () {
      props.dispatch({ type: "LOGIN" });
      props.dispatch({ type: "USERID", id: xhr.responseText });
    };

    var highResimageUrl = getHigherResProviderPhotoUrl(
      response.profileObj.imageUrl,
      "google"
    );

    var givenName = response.profileObj.givenName;
    var familyName = response.profileObj.familyName;

    xhr.send(
      "idtoken=" +
        id_token +
        "&imgURL=" +
        highResimageUrl +
        "&fname=" +
        givenName +
        "&lname=" +
        familyName
    );
    document.cookie =
      "ziroatoken=" + id_token + ";domain=;Secure;SameSite=None";

    setUserURL(highResimageUrl);
    localStorage.setItem("profile_image_url", highResimageUrl);
    props.dispatch({ type: "USERIMG", url: highResimageUrl });
    setLoggedIn(true);
    localStorage.setItem("loggedin", "true");
    //window.location.reload();
  };

  useEffect(() => {
    if (userObj) {
      // check if user obj contains tokenObj
      if (userObj.tokenObj) {
        setRefreshTimeout(userObj.tokenObj.expires_at);
      }
    }
  }, [userObj]);

  const reloadAuthToken = () => {
    userObj.reloadAuthResponse().then(
      // success handler.
      (authResponse) => {
        // The GoogleUser is mutated in-place, this callback updates component state.
        responseGoogle(authResponse);
      },
      // fail handler.
      (failResponse) => {
         this.accessToken = "";
         console.log("Could not refresh token");
         console.log(failResponse);
      }
    );
  }

  const setRefreshTimeout = (expiresAt) => {
    // Either 5 minutes before the deadline, or 5 minutes from now. This
    // should prevent thrashing while keeping the credentials fresh.
    const oneMin = 60 * 1000;
    var refreshDeadline =  Math.max(
      5*oneMin,
      expiresAt - Date.now() - (5*oneMin));
    // console.log("Refreshing credentials in "
    //             + Math.floor(refreshDeadline/oneMin).toString()
    //             + " minutes");
    setTimer(setTimeout(reloadAuthToken, refreshDeadline));
  };

  const logout = () => {
    localStorage.setItem("loggedin", "false");
    localStorage.removeItem("profile_image_url");
    setLoggedIn(false);
    document.cookie =
      "ziroatoken=; expires = Thu, 01 Jan 1970 00:00:00 UTC; path=/"; //set date in past to delete cookie
    if(history.location.pathname === "/user-view" && history.location.search === "" || history.location.pathname === "/user-profile"){
      history.push("/explore");  
    } 
    window.location.reload();
    clearTimeout(timer);
    setTimer(null);
  };

  React.useEffect(() => {
    window.addEventListener("resize", updateColor);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.removeEventListener("resize", updateColor);
    };
  });
  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && collapseOpen) {
      setcolor("bg-white");
    } else {
      setcolor("navbar-transparent");
    }
  };
  // this function opens and closes the collapse on small devices
  const toggleCollapse = () => {
    if (collapseOpen) {
      setcolor("navbar-transparent");
    } else {
      setcolor("bg-white");
    }
    setcollapseOpen(!collapseOpen);
  };
  // this function is to open the Search modal
  const toggleModalSearch = () => {
    setmodalSearch(!modalSearch);
  };
  return (
    <>
      <Navbar className={classNames("navbar-absolute", color)} expand="lg">
        <Container fluid>
          <div className="navbar-wrapper">
            <div
              className={classNames("navbar-toggle d-inline", {
                toggled: props.sidebarOpened,
              })}
            >
              <NavbarToggler onClick={props.toggleSidebar}>
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </NavbarToggler>
            </div>
            <NavbarBrand href="/explore">
              {props.brandText}
            </NavbarBrand>
          </div>
          <NavbarToggler onClick={toggleCollapse}>
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </NavbarToggler>
          <Collapse navbar isOpen={collapseOpen}>
            <Nav className="ml-auto" navbar>
              {loggedIn ? (
                <UncontrolledDropdown nav>
                  <DropdownToggle
                    caret
                    color="default"
                    nav
                    onClick={(e) => e.preventDefault()}
                  >
                    <div className="photo">
                      <img alt="..." src={userImgURL} />
                    </div>
                    <b className="caret d-none d-lg-block d-xl-block" />
                    <p className="d-lg-none">Account</p>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-navbar" right tag="ul">
                    <NavLink tag="li">
                      <Link to={{ pathname: "/user-profile" }}>
                        <DropdownItem className="nav-item" style={{color: "#3d3d3d"}}>
                          Profile
                        </DropdownItem>
                      </Link>
                    </NavLink>
                    <NavLink tag="li">
                      <Link to={{ pathname: "/settings" }}>
                        <DropdownItem className="nav-item" style={{color: "#3d3d3d"}}>
                          Settings
                        </DropdownItem>
                      </Link>
                    </NavLink>
                    <DropdownItem divider tag="li" />
                    <NavLink tag="li">
                      <DropdownItem className="nav-item">
                        <GoogleLogout
                          clientId={globalClientId}
                          buttonText={"Logout"}
                          onLogoutSuccess={logout}
                          onFailure={logout}
                          isSignedIn={false}
                          className="google-login-button-mine"
                        />
                      </DropdownItem>
                    </NavLink>
                  </DropdownMenu>
                </UncontrolledDropdown>
              ) : (
                <br></br>
              )}
              {loggedIn ? (
                <br></br>
              ) : (
                <GoogleLogin
                  style={{ borderRadius: 100 }}
                  clientId={globalClientId}
                  buttonText={"Login"}
                  onSuccess={responseGoogle}
                  onFailure={responseGoogle}
                  cookiePolicy={"single_host_origin"}
                  isSignedIn={true}
                  className="google-login-button-mine"
                  uxMode="popup"
                />
              )}
              <li className="separator d-lg-none" />
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
      <Modal
        modalClassName="modal-search"
        isOpen={modalSearch}
        toggle={toggleModalSearch}
      >
        <ModalHeader>
          <Input placeholder="SEARCH" type="text" />
          <button
            aria-label="Close"
            className="close"
            onClick={toggleModalSearch}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
        </ModalHeader>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});
export default connect(mapStateToProps)(AdminNavbar);
